export default {
  tryNow: "立即尝试",
  retry: "重试",
  back: "返回首页",
  backToList: "返回文章列表",
  read: "阅读更多",
  readMore: "阅读更多 →",
  filter: "按栏目筛选",
  all: "全部文章",
  articles: "篇文章",
  noData: "暂无文章",
  tryDifferentFilter: "尝试选择不同的栏目",
  loading: "加载中...",
  notFound: "文章未找到",
  articleNotFound: "您查找的文章不存在或已被删除",
  previous: "上一篇",
  next: "下一篇",
  previousArticle: "上一篇",
  nextArticle: "下一篇",
  relatedArticles: "相关文章",
  topicNotFound: "话题未找到",
  topicNotFoundDescription: "您查找的话题不存在。",
  noArticles: "暂无文章",
  noArticlesDescription: "该分类下暂无文章。",
  explore: "探索",
  allArticles: "全部文章",
  browseBlog: "浏览博客",
  categories: "分类",
  popularTags: "热门标签",
  showAllTags: "查看全部标签",
  showFewerTags: "收起标签",
};
